let SleepChart = function (props) {
  let { series, transitions } = props;

  let points = [
    [125.25, 45.25],
    [68.75, 68.75],
    [181.75, 68.75],
    [45.25, 125.25],
    [125.25, 125.25],
    [205.25, 125.25],
    [68.75, 181.75],
    [181.75, 181.75],
    [125.25, 205.25] 
  ];

  let counts = {
    "NA/LYING_CHEST": 0,
    "LYING_LEFT/LYING_CHEST": 0,
    "LYING_RIGHT/LYING_CHEST": 0,
    "LYING_LEFT/NA": 0,
    "NOT_LYING": 0,
    "LYING_RIGHT/NA": 0,
    "LYING_LEFT/LYING_BACK": 0,
    "LYING_RIGHT/LYING_BACK": 0,
    "NA/LYING_BACK": 0
  };

  series.forEach(function ({ value }) {
    if (value) {
      let key = value.c + "/" + value.s;

      if (key !== "NA/NA") {
        if (counts[key] === undefined) {
          key = "NOT_LYING";
        }

        counts[key]++;
      }
    }
  });

  let circles = Object.keys(counts).map(function (key, i) {
    let count = counts[key];
    let [x, y] = points[i];
    let label = tx("posture." + key);
    let duration = count * mc.math.MILLIS_PER_MINUTE;

    if (count > 0) {
      return (
        <circle
          key={key}
          cx={x}
          cy={y}
          r={Math.max(6, Math.sqrt(count) * 2.5)}
          data-tooltip={label + " (" + mc.format.duration(duration) + ")"}/>
      );
    }

    return null;
  });

  return (
    <svg className="rc-sleep-chart" width="250" height="250">
      <image xlinkHref="./img/rc/sleep.svg" width="250" height="250"/>
      <text x="8" y="240">
        {tx("count_transitions", { _count: transitions || 0 })}
      </text>
      {circles}
    </svg>
  );
};

module.exports = SleepChart;